ge<template>
  <div id="app" :class="containerClasses">
     <header id="top-nav">
      <div class="inner">
        <h1 id="site-name" @click="revealStrapline()"><router-link v-bind:to="'/projects'">{{title}}</router-link></h1>
         <nav class="main-nav">
            <ul class="menu">
              <li v-for="item in menu"><router-link v-bind:to="item.link">{{item.title}}</router-link></li>
           </ul>
         </nav>
         <div class="site-info" @click="clearLocalStorage()" :class="{'is-admin': isAdmin,'show-message': showStatusMsg}">
          <h5 class="owner">{{owner}}</h5>
          <p class="strapline">{{strapline}}</p>
          <p class="status-message">{{statusMsg}}</p>
        </div>
         <div class="menu-toggle" v-on:click.stop="menuToggle()">Menu</div>
      </div>
      
     </header>
     <keep-alive>
      <router-view :is-admin="isAdmin" :win-width="winWidth" :win-height="winHeight" :prev-y="prevY" :prev-stop-y="prevStopY"></router-view>
    </keep-alive>
    <div class="admin-pane" id="admin-pane" v-if="isAdmin">
      <div class="close-admin" v-on:click.stop="closeAdmin()">X</div>
      <iframe v-if="hasAdminUrl" :src="adminPath" class="admin-frame"></iframe>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

function scrollY () {
  if (window.pageYOffset) { return window.pageYOffset }
  return Math.max(document.documentElement.scrollTop, document.body.scrollTop)
}

function winWidth () {
  if (document.documentElement && document.documentElement.clientWidth) {
    return document.documentElement.clientWidth
  }
  if (document.body) {
    return document.body.clientWidth
  }
}

function isTouchDevice () {
  try {
    document.createEvent('TouchEvent')
    return true
  } catch (e) {
    return false
  }
}

export default {
  name: 'app',
  data: function () {
    return {
      init: false,
      alias: 'home',
      title: 'typeandline',
      owner: 'Dominic Dyson',
      strapline: 'indepedent graphic design',
      shuffle: false,
      clearTs: 0,
      straplineShown: false,
      containerClasses: [],
      nodes: [],
      infoLoaded: false,
      isAdmin: false,
      adminUrl: '',
      adminPath: '',
      statusMsg: '',
      showStatusMsg: false,
      hasAdminUrl: false,
      editedChecked: false,
      scrolling: false,
      scrollY: 0,
      prevY: 0,
      prevStopY: 0,
      stop: 0,
      halfWY: 0,
      winHeight: 0,
      winWidth: 0,
      pageHeight: 0,
      user: {},
      menu: [{
        link: '/',
        title: 'Projects'
      }],
      backend: 'http://tal.platform-3.co.uk/'
    }
  },
  created: function () {
    if (process.env) {
      if (process.env.BACKEND) {
        this.backend = process.env.BACKEND
      }
    }
    if (window.location.pathname) {
      var pn = window.location.pathname
      var currHash = window.location.hash
      if (pn.length < 3 && currHash.length < 3) {
        pn = '/projects'
      }
      if (pn.length > 1) {
        if (typeof history.replaceState === 'function') {
          history.pushState({mode: pn}, pn, '/')
          if (pn.indexOf('/index.') !== 0) {
            var newHash = '#' + pn
            if (newHash !== currHash) {
              window.location = newHash
            }
          }
        }
      }
    }
    this.checkSiteInfo()
    this.updateWrapperClass()
    if (isTouchDevice()) {
      this.addContainerClass('touch-enabled')
    }
    this.checkLoggedin()
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('keydown', this.handleKeys)
    this.handleResize(true)
    var comp = this
    setTimeout(function () {
      comp.init = true
      window.addEventListener('hashchange', comp.updateWrapperClass)
    }, 500)
    setTimeout(function () {
      if (!comp.editedChecked) {
        comp.checkEdited()
      }
    }, (30 * 1000))
  },
  watch: {
    adminUrl: function () {
      this.hasAdminUrl = this.adminUrl.length > 3
      if (this.hasAdminUrl) {
        this.adminPath = 'http://tal.platform-3.co.uk' + this.adminUrl
        this.addContainerClass('show-admin')
      } else {
        this.adminPath = ''
        this.removeContainerClass('show-admin')
      }
    }
  },
  methods: {
    path: function () {
      return window.location.hash
    },
    checkLoggedin: function () {
      var comp = this
      var ts = new Date().getTime()
      this.$http.get(this.backend + 'jsonstyles/user?ts=' + ts)
      .then(function (response) {
        if (response.data) {
          if (typeof comp === 'object') {
            comp.user = response.data
            if (comp.user.roles) {
              comp.isAdmin = comp.user.is_editor
              if (this.backend === '/tal/') {
                comp.isAdmin = true
              }
              if (comp.isAdmin) {
                comp.checkEdited()
              }
            }
          }
        }
      }, function (response) {})
    },
    checkSiteInfo: function () {
      var data = this.$ls.get('sitedata', null)
      var ts = new Date().getTime()
      var prevTs = this.$ls.get('ts')
      if (data !== null) {
        this.loadSiteInfo(data)
      } else {
        var matched = false
        if ($preload.site_info) {
          if ($preload.site_info.menu) {
            if ($preload.site_info.menu instanceof Array) {
              matched = true
              this.loadSiteInfo($preload.site_info)
            }
          }
        }
        if (!matched) {
          this.fetchSiteInfo(ts)
        }
      }
      if ((ts - prevTs) > (15 * 60 * 1000)) {
        var comp = this
        setTimeout(function () {
          comp.fetchSiteInfo(ts)
        }, 5000)
      }
    },
    fetchSiteInfo: function (ts) {
      var comp = this
      this.$http.get(this.backend + 'jsonstyles/siteinfo')
      .then(function (response) {
        if (response.data) {
          if (typeof response.data === 'object') {
            comp.loadSiteInfo(response.data)
            comp.$ls.set('sitedata', response.data, (7 * 24 * 60 * 60 * 1000))
            this.$ls.set('ts', ts)
          }
        }
      }, function (response) {})
    },
    loadSiteInfo: function (data) {
      if (data.site_name) {
        this.title = data.site_name
      }
      if (data.menu) {
        this.menu = data.menu
      }
      if (data.owner) {
        this.owner = data.owner
      }
      if (data.strapline) {
        this.strapline = data.strapline
      }
      if (data.shuffle) {
        this.shuffle = data.shuffle === 1
      }
      if (data.nodes && data.nodes instanceof Array) {
        this.nodes = data.nodes
        var comp = this
        setTimeout(function () {
          var alias = window.location.hash.replace(/^#/, '')
          var otherNodes = _.filter(comp.nodes, function (n) {
            return n.alias !== alias && n.alias.indexOf('/projects') !== 0
          })
          if (otherNodes.length > 0) {
            for (var i = 0; i < otherNodes.length; i++) {
              comp.getNode(otherNodes[i].nid, null, true)
            }
          }
        }, 1000)
        this.infoLoaded = true
      }
    },
    checkEdited: function () {
      this.$http.get(this.backend + 'jsonstyles/edited')
      .then(function (response) {
        if (response.data) {
          if (typeof response.data === 'object') {
            if (response.data.nodes) {
              this.$ls.set('editednodes', response.data)
              var sd = this.$ls.get('sitedata');
              var comp = this
              if (sd) {
                if (sd.nodes) {
                  _.each(response.data.nodes, function (n) {
                    var isProject = /^\/?projects\//.test(n.alias)
                    var n2 = _.find(sd.nodes, function (sn) {
                      return n.nid === sn.nid
                    })
                    var changed = true
                    if (n2 !== undefined) {
                      if (n2.changed) {
                        changed = parseInt(n.changed) > parseInt(n2.changed)
                      }
                    }
                    if (changed) {
                      if (isProject) {
                        comp.$ls.remove('projects-full')
                        comp.$ls.remove('projects-full-more')
                      } else {
                        comp.$ls.remove('node-full/' + n.nid)
                      }
                    }
                  })
                }
              }
              this.editedChecked = true
            }
          }
        }
      })
      .catch(function(e) {
        console.log(e)
      })
    },
    getNode: function (nid, callback) {
      var refName = 'node-full/' + nid
      var data = this.$ls.get(refName, null)
      var edited = this.$ls.get('editednodes')
      if (edited) {
        if (edited.total && data !== null) {
          if (edited.total > 0) {
            var index = _.findIndex(edited.nodes, function (n) {
              return n.nid === nid
            })
            if (index >= 0) {
              if (edited.nodes[index]) {
                var n = edited.nodes[index]
                if (n.changed > data.changed) {
                  data = null
                }
              }
            }
          }
        }
      }
      if (data !== null) {
        if (callback) {
          callback(data)
        }
      } else {
        var plRef = refName.replace(/\//g, '__').replace(/-/g,'_')
        var matched = false
        if ($preload) {
          if ($preload[plRef]) {
            if ($preload[plRef].valid) {
              if (callback) {
                callback($preload[plRef])
              }
              matched = true
            }
          }
        }
        if (!matched) {
          this.fetchNode(refName, callback)
        }
      }
    },
    fetchNode: function (refName, callback, preFetch) {
      var comp = this
      this.$http.get(this.backend + 'jsonstyles/' + refName).then(function (response) {
        if (response.data instanceof Object) {
          comp.$ls.set(refName, response.data, (24 * 60 * 60 * 1000))
          if (callback) {
            callback(response.data, refName)
          }
        }
      }, function (response) {
        if (preFetch !== true) {
         console.log("404 not found")
        }
      })
    },
    calcPageHeight: function () {
      var B = document.body
      var H = document.documentElement
      return Math.max(B.scrollHeight, B.offsetHeight, H.clientHeight, H.scrollHeight, H.offsetHeight)
    },
    scrollTo: function (offsetY, reset) {
      if (this.scrolling === false) {
        this.scrolling = true
        var comp = this
        this.$scrollTo('body', 250, {
          offset: offsetY,
          easing: 'ease-in',
          cancelable: true,
          onDone: function () {
            comp.scrolling = false
          },
          onCancel: false
        })
        if (!reset) {
          reset = 1000
        }
        setTimeout(function () {
          comp.scrolling = false
        }, reset)
      }
    },
    handleScroll: function () {
      this.scrollY = scrollY()
      if (this.stopY > 0) {
        if (this.scrollY > (this.prevY + this.stopY) || this.scrollY < (this.prevY - this.stopY)) {
          this.prevStopY = this.prevY
          this.prevY = this.scrollY
          var sdClassIndex = this.containerClasses.indexOf('scrolled-down')
          if (this.scrollY > this.winHeight / 16) {
            if (sdClassIndex < 0) {
              this.addContainerClass('scrolled-down')
              this.straplineShown = true
            }
          } else {
            if (sdClassIndex >= 0) {
              if (this.straplineShown === true) {
                this.removeContainerClass('show-top-info')
              }
              this.removeContainerClass('scrolled-down')
            }
          }
        }
      }
    },
    handleResize: function (init) {
      this.pageHeight = this.calcPageHeight()
      this.winHeight = window.innerHeight
      this.winWidth = winWidth()
      if (init === true) {
        this.stopY = this.winHeight / 64
        this.halfWY = this.winHeight / 2
      }
    },
    revealStrapline: function () {
      this.straplineShown = false
      this.updateWrapperClass()
    },
    handleKeys: function (e) {
      var alias = window.location.hash.replace(/^#/, '')
      switch (e.keyCode) {
        case 27:
          if (/\/projects\/\w+/.test(alias)) {
            window.location = '#/projects'
          }
          break
        case 37:
          window.history.back()
          break
        case 39:
          window.history.forward()
          break
      }
    },
    updateWrapperClass: function (e) {
      var hash = window.location.hash
      var wrapperClass = 'home'
      if (hash.length > 2) {
        var parts = hash.split('/')
        parts.shift()
        if (parts.length > 0) {
          wrapperClass = parts.join('-')
        }
      }
      this.removeContainerClass('show-top-info')
      this.removeContainerClass('show-menu')
      var i = 0
      var cls = []
      var cl
      for (; i < this.containerClasses.length; i++) {
        cl = this.containerClasses[i]
        if (/^(project|home|contact|about)/.test(cl) === false) {
          cls.push(cl)
        }
      }
      this.containerClasses = cls
      this.addContainerClass(wrapperClass)
      switch (wrapperClass) {
        case 'info':
        case 'about':
        case 'contact':
          this.straplineShown = false
          break
      }
      if (this.straplineShown !== true && /projects-\w+/.test(wrapperClass) === false) {
        this.addContainerClass('show-top-info')
        this.straplineShown = true
        var comp = this
        setTimeout(function () {
          comp.straplineShown = false
        }, (15 * 60 * 1000))
      }
    },
    menuToggle: function () {
      var index = this.containerClasses.indexOf('show-menu')
      if (index < 0) {
        this.containerClasses.push('show-menu')
      } else {
        this.containerClasses.splice(index, 1)
      }
    },
    clearLocalStorage: function () {
      if (this.isAdmin) {
        var ts = Math.floor(new Date().getTime() / 1000)
        if ((ts - 5) > this.clearTs) {
          this.$ls.clear()
          this.clearTs = ts
          this.checkSiteInfo()
          this.statusMsg = 'Local caches cleared'
          this.showStatusMsg = true
          switch (this.alias) {
            case 'home':
              this.$emit('reload-projects')
              break;
          }
          var comp = this
          setTimeout(function () {
            comp.showStatusMsg = false
          }, 2000)
          setTimeout(function () {
            comp.statusMsg = '';
          }, 3000)
        }
      }
    },
    addContainerClass: function (clsName) {
      this.toggleContainerClass(clsName, 'add')
    },
    removeContainerClass: function (clsName) {
      this.toggleContainerClass(clsName, 'rem')
    },
    toggleContainerClass: function (clsName, mode) {
      var index = this.containerClasses.indexOf(clsName)
      if (mode === 'add' && index < 0) {
        this.containerClasses.push(clsName)
      } else if (index >= 0) {
        switch (mode) {
          case 'rem':
          case 'remove':
            this.containerClasses.splice(index, 1)
            break
        }
      }
    },
    closeAdmin: function () {
      this.adminUrl = ''
      this.checkEdited()
    },
    slidesRefName: function (more) {
      var refName = 'projects-full'
      if (more) {
        refName += '-more'
      }
      return refName
    }
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?3581a5c8